export default "__VITE_ASSET___app/immutable/assets/default-avatar-3.BfNjwnHn.svg__"